<sf-loader></sf-loader>
<sf-notification></sf-notification>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<div class="col-12 ">
    <div class="formgrid grid">
        <div class="field col-12 md:col-12 lg:col-6 xl:col-6">
            <label for="login" class="font-medium hidden md:block text-xl">
                <span translate>label.login_email</span>
            </label>
            <input pInputText type="text" id="login" [(ngModel)]="item.login"
                [disabled]="(!canUpdate || !canChangeLogin) && isNew" class="w-full" />
            <small *ngIf="isFieldValid('login')" class="p-invalid" translate>validation_errors.required_field</small>
        </div>

        <div class="field col-12 md:col-12 lg:col-6 xl:col-6">
            <label class="font-medium hidden md:block text-xl"><span
                    translate>label.access_profile</span></label>
            <sc-role-dropdown [id]="item.scRoleId" (chosedItem)="reciverFeedbackRole($event)"
                [disabled]="!canUpdate || isMyData " >
            </sc-role-dropdown>
            <small *ngIf="isFieldValid('roleId')" class="p-invalid" translate>validation_errors.required_field</small>
        </div>



        <!-- <div class="field col-12 md:col-12 lg:col-6 xl:col-4">
            <label for="login" class="font-medium hidden md:block text-2xl">
                <span translate>label.default_language</span>
            </label>
            <input pInputText
                type="text"
                id="languageCode"
                [(ngModel)]="item.languageCode"
                [disabled]="!canUpdate && !isMyData"
                class="w-full text-xl"/>
        </div> -->
    </div>

    <div class="formgrid grid">

        <div class="field col-12 md:col-12 lg:col-12 xl:col-8">
            <label for="email" class="font-medium hidden md:block text-xl">
                <span translate>label.email</span>
            </label>
            <input pInputText type="text" id="email" [(ngModel)]="item.email" autofocus class="w-full"
                email="true" [disabled]="!canUpdateEmail" />
            <!-- <small *ngIf="(!item.email || invalidEmail) && isLoaded"  class="p-invalid" translate>validation.invalid_field</small> -->
            <small *ngIf="isFieldValid('email')" class="p-invalid" translate>validation_errors.required_field</small>
        </div>

        <div class="field col-12 md:col-12 lg:col-12 xl:col-4">
            <label for="phone" class="font-medium hidden md:block text-xl">
                <span translate>label.phone_number</span>
            </label>
            <p-inputMask mask="(99) 99999-9999" [(ngModel)]="item.phone" placeholder="(99) 99999-9999" inputId="phone"
                styleClass="mask" [disabled]="!canUpdate" [style]="{'width':'100%'}" class="w-full">
            </p-inputMask>
            <small *ngIf="isFieldValid('phone')" class="p-invalid" translate>validation_errors.required_field</small>
        </div>
    </div>

    <div class="formgrid grid">
        <div class="field col-12 md:col-12 lg:col-12 xl:col-12">
            <label for="name" class="font-medium hidden md:block text-xl">
                <span translate>label.name</span></label>
            <input pInputText type="text" id="name" [(ngModel)]="item.name" required class="w-full"
                [disabled]="!canUpdate && !isMyData" />
            <!-- <small class="p-invalid" *ngIf="!item.name && isLoaded" translate>validation.required_field</small> -->
            <small *ngIf="isFieldValid('name')" class="p-invalid" translate>validation_errors.required_field</small>
        </div>

        <!-- <div class="field col-12 md:col-12 lg:col-8 xl:col-8">
            <label for="structure" class="font-medium hidden md:block text-2xl"><span translate>label.organizational_structure</span> (<span translate>label.access_level</span>)</label>
            <div *ngIf="canUpdate && !isMyData">
                <sf-organizationStructure-tree
                    [id]="detailItem.scOrganizationStructureId"
                    (chosedItem)="reciverFeedbackStructure($event)"
                    [placeHolderLanguage]="'label.select_organization_structure' | translate"
                    class=" text-xl text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round outline-none focus:border-primary w-full"
                    style="appearance: auto;"
                    styleClass="text-xl">
                </sf-organizationStructure-tree>
            </div>
            <div *ngIf="!canUpdate || isMyData">
                <input pInputText
                type="text"
                id="scOrganizationStructureName"
                [(ngModel)]="item.scOrganizationStructureName"
                required
                class="w-full text-xl"
                disabled/>
            </div>
        </div> -->


    </div>

    <div class="formgrid grid mt-2" *ngIf="isMyData && isAdmin">
        <div class="field col-12 md:col-12 lg:col-4 xl:col-4">
            <div class="field-checkbox">
                <p-checkbox ngDefaultControl [(ngModel)]="item.isBlocked" binary="true" id="flBloqueado" name="flAtivo"
                    class="p-d-inline" [disabled]="!canUpdate">
                </p-checkbox>
                <label for="flBloqueado" class="font-medium hidden md:block text-xl"><span
                        translate>label.bloked_user</span></label>
            </div>
        </div>

        <div class="field col-12 md:col-12 lg:col-4 xl:col-4">
            <div class="field-checkbox">
                <p-checkbox ngDefaultControl [(ngModel)]="item.isFirstAccess" binary="true" id="isFirstAccess"
                    name="isFirstAccess" class="p-d-inline" [disabled]="!canUpdate">
                </p-checkbox>
                <label for="isFirstAccess" class="font-medium hidden md:block text-xl"><span
                        translate>label.first_access</span></label>
            </div>
        </div>

        <div class="field col-12 md:col-12 lg:col-4 xl:col-4">
            <div class="field-checkbox">
                <p-checkbox ngDefaultControl [(ngModel)]="item.isEmailConfirmed" binary="true" id="flAtivo"
                    name="isEmailConfirmed" class="p-d-inline" [disabled]="!canUpdate">
                </p-checkbox>
                <label for="isEmailConfirmed" class="font-medium hidden md:block text-xl"><span
                        translate>label.email_verified</span></label>
            </div>
        </div>
    </div>

    <div class="c-item-registration__footer">
        <div>
            <div class="grid" style="justify-content: end;">
                <div *ngIf="isMyData" class="col-12 md:col-12 lg:col-12 xl:col-4">
                    <button pButton pRipple icon="pi pi-eye"
                        class="p-button-info text-xl font-semibold w-full" [label]="'button.pwd_update' | translate"
                        (click)="onShowPwdUpdate()">
                    </button>
                </div>
                <div *ngIf="!isNew && !isMyData" [class]="'col-12 sm:col-6 md:'+(isMyData ? 'col-4' : 'col-2') +' lg:'+(isMyData ? 'col-4' : 'col-2')">
                    <button pButton pRipple icon="pi pi-times"
                        class="text-xl font-semibold p-button-outlined w-full" size="large" [label]="'button.cancel' | translate"
                        (click)="cancelUserUpdate();">
                    </button>
                </div>
                <div *ngIf="!isNew && !isMyData" [class]="'col-12 sm:col-6 md:'+(isMyData ? 'col-4' : 'col-2') +' lg:'+(isMyData ? 'col-4' : 'col-2')">
                    <button pButton pRipple icon="pi pi-save" class="text-xl font-semibold w-full"
                        [label]="'button.save' | translate" (click)="saveItem();" [disabled]="isFieldValid('all')">
                    </button>
                </div>
            </div>
        </div>
    </div>

</div>

<p-dialog [(visible)]="dialogPwdUpdate" [style]="{width: '450px'}" [modal]="true" styleClass="p-fluid" [header]="'label.pwd_update' | translate">

    <ng-template pTemplate="content">
    <form [formGroup]="passwordForm" (ngSubmit)="savePwdUpdate()">
        <div class="card flex justify-content-center">
            <div class="password-container col-12">
                <label for="password">Senha:</label>
                <input pInputText formControlName="password" type="password" id="password" placeholder="" />
                <span id="togglePassword" class="icon-eye"></span>
                <div class="p-invalid" *ngIf="passwordForm.get('password')?.invalid && passwordForm.get('password')?.touched">
                    <span translate>A senha é obrigatória e deve ter pelo menos 3 caracteres.</span>
                </div>
            </div>
        </div>

        <div class="card flex justify-content-center">
            <div class="password-container col-12">
                <label for="confirmPassword">Confirmar Senha:</label>
                <input pInputText formControlName="confirmPassword" type="password" id="confirmPassword" placeholder="" />
                <span id="togglePassword" class="icon-eye"></span>
                <div class="p-invalid" *ngIf="passwordForm.hasError('passwordsMismatch') && passwordForm.touched">
                    <span translate>label.errorPwdConfirmation</span>
                </div>
            </div>
        </div>
        <div style="float: right;">
            <button pButton pRipple
                type="button"
                icon="pi pi-times"
                style="width: 110px; margin: 3px;"
                class="p-button-danger p-mr-2 mt-3"
                [label]="'button.cancel' | translate"
                (click)="cancelPwdUpdate()">
            </button>
            <button pButton pRipple
                type="submit"
                icon="pi pi-check"
                style="width: 110px; margin: 3px;"
                class="p-button-success p-mr-2 mt-3"
                [label]="'button.confirm' | translate"
                [disabled]="passwordForm.invalid">
            </button>
        </div>
        </form>

    </ng-template>

    <ng-template pTemplate="footer">

    </ng-template>
</p-dialog>
